var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.onClick}},[(_vm.loading)?_c('span',{staticClass:"text"},[_c('loader')],1):_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }